var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideFooter)?_c('div',{class:{ 'home-route-footer': _vm.isHomeRoute },staticStyle:{"border-top":"1px solid rgb(163, 163, 163)"},attrs:{"id":"footer"}},[_c('footer-content-component'),_c('div',[_c('div',{staticClass:"footer-copyright text-center mt-2 pb-4"},[_vm._v(" AIRspirit © "+_vm._s(_vm.currentYear)+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }